module.exports = __webpack_public_path__ + "img/20171113190920_51745.141a8708.jpg";